import { IsBoolean } from 'class-validator';

export class UpdateResidentCashPayerStateDto {
  @IsBoolean()
  cashPayer!: boolean;
}
